export const doctorApproveModal_style = {
  rootSx: {
    padding: 2,
  },
  cardSx: {
    padding: 0.1,
  },
  rootCardSx: {
    mt: 6,
  },
  smsTextSx: {
    mt: 6,
  },
  profilepicSx: {
    mr: 0,
  },
  description: {
    fontSize: '20px',
    fontWeight: 500,
    color: '#0F0B11',
    textAlign: 'center',
  },
  closebuttonSx: {
    mr: 2,
    maxWidth: '120px',
    bgcolor: '#007965',
    color: 'white',
    textTransform: 'capitalize',
    borderRadius: '8px',
    // '&:hover': {
    //   color: 'primary.light',
    // },
    border: '2px solid #007965',
  },
  buttonSx: {
    textTransform: 'none',
    color: 'white',
    bgcolor: 'primary.main',
    '&:hover': {
      bgcolor: 'primaryTints.200',
    },
  },
  cancelbuttonSx: {
    mr: 2,
    mb: 2,
    bgcolor: '#007965',
    color: 'white',
    textTransform: 'capitalize',
    borderRadius: '8px',
    '&:hover': {
      color: 'white',
      bgcolor: '#007965',
    },
    border: '2px solid #007965',
  },
  DeletebuttonSx: {
    ml: 2,
    // maxWidth: '120px',
    bgcolor: '#F44F5A',
    textTransform: 'capitalize',
    color: 'white',
    borderRadius: '8px',
    '&:hover': {
      bgcolor: '#F44F5A',
    },
    '&:focus': {
      bgcolor: '#F44F5A',
    },
    border: '2px solid #F44F5A',
  },

  totalModalSx: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 375,
    border: '0px solid',
    boxShadow: 24,
    backgrounColor: '#FFF',
    // p: 2,
    outline: '0px',
  },
  totalBoxSx: {
    backgroundColor: 'common.white',
    px: 6,
    pt: 2,
    borderRadius: '8px',
    width: 400,
    minWidth: '426px',
    minHeight: '190px',
    margin: '0px auto',
  },
  totalMobileBoxSx: {
    backgroundColor: 'common.white',
    // px: 6,
    // pt: 2,
    borderRadius: '8px',
    minHeight: '190px',
    margin: '0px auto',
  },

  centerIconSx: {
    display: 'flex',
    justifyContent: 'center',
    alignitems: 'center',
  },
  onClearSx: {
    bgcolor: '#FFEAEC',
    color: 'error.main',
    '&:hover': {
      bgcolor: '#FFEAEC',
    },
  },
};
